<script>
    import axios from 'axios'
    import AppMixin from './../../../mixins/AppMixin'
    import 'vue3-swatches/dist/style.css'
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import {store} from "../store";
    import Fieldset from "primevue/fieldset";
    import Checkbox from "primevue/checkbox";
    import ColorPicker from 'primevue/colorpicker';

    export default {
        mixins: [AppMixin],
        data () {
            return {
                name: "KSSettingCluster",
                loading: false,
                error: null,
                model: {
                    view:{
                        treeNodeName: {
                            keys_count: {},
                            max_key_ws: {},
                            max_key_wsk: {},
                            max_key_superwsk: {},
                            ws_sum: {},
                            wsk_sum: {},
                            superwsk_sum: {}
                        }
                    },
                    sort: {
                        field: null,
                        dir: null
                    }
                },
                store: store,
            }
        },
        methods: {
            save() {
                let self = this;
                self.loading = true;
                axios({
                    method: 'post',
                    url: this.apiUrl,
                    withCredentials: true,
                    data: this.model
                })
                .then(function (response) {

                    let isReload = false;

                    if(JSON.stringify(self.model.sort) !== JSON.stringify(self.getSetting.sort)){
                        isReload = true;
                    }

                    self.store.mutations.setSetting(self.model);
                    self.loading = false;
                    self.$snotify.info(self.$t('lang.cluster.setting_success'), {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                    self.onClose();

                    if(isReload){

                        self.$emitter.emit(Listeners.CLUSTER_TREE_RELOAD);

                    }

                }).catch(function (error) {

                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                });
            },
            enabled(field, dir){
                return {'sort_enabled': this.model.sort.field === field && this.model.sort.dir === dir};
            },
            toggle(field, dir){

                this.model.sort = {
                    field: field,
                    dir: dir
                }

            },
            onOpen() {
                this.model = JSON.parse(JSON.stringify(this.getSetting));
            },
            onClose() {
                this.$emitter.emit(this.getListenerCloseDialog);
            }
        },
        computed: {
            getSetting() {
                return this.store.getters.setting();
            },
            apiUrl(){
                return this.$config.API_URL + '/clustering/setting';
            },
            getListenerOpenDialog() {
                return Listeners.CLUSTER_POPUP_SETTING_OPEN;
            },
            getListenerCloseDialog() {
                return Listeners.CLUSTER_POPUP_SETTING_CLOSE;
            }
        },
        components: {
            AdaptersDialog,
            Fieldset,
            Checkbox,
            ColorPicker,
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerOpenDialog"
        :listener-close-id="getListenerCloseDialog"
        :callback-on-show="onOpen"
        :header="$t('lang.cluster.main_setting')"
        :loading="loading"
        :callback-agree="save"
        :button-agree-label="$t('lang.main.btn.save')"
        :callback-on-hide="onClose"
    >
        <template #content>
            <Fieldset :legend="$t('lang.cluster.display_folder')">
                <table>
                    <thead>
                    <tr>
                        <th colspan="2"><span>{{$t('lang.cluster.value')}}</span></th>
                        <th><span>{{$t('lang.cluster.color')}}</span></th>
                        <th><span>{{$t('lang.cluster.background')}}</span></th>
                        <th><span>{{$t('lang.cluster.sorting')}}</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><Checkbox :modelValue="true" binary disabled /></td>
                        <td class="vertical-align-middle">{{$t('lang.main.f_key_label')}}</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">
                            <span class="span_sort" @click="toggle('name', 'asc')"><i class="fa fa-sort-amount-asc sort" aria-hidden="true" :class="enabled('name', 'asc')"></i></span>
                            <span class="span_sort" @click="toggle('name', 'desc')"><i class="fa fa-sort-amount-desc sort" aria-hidden="true" :class="enabled('name', 'desc')"></i></span>
                        </td>
                    </tr>
                    <tr>
                        <td><Checkbox v-model="model.view.treeNodeName.keys_count.enabled" binary /></td>
                        <td class="vertical-align-middle">{{$t('lang.cluster.common_key_count').capitalize()}}</td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.keys_count.color" /></div></td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.keys_count.background" /></div></td>
                        <td align="center">
                            <span class="span_sort" @click="toggle('keys_count', 'asc')"><i class="fa fa-sort-amount-asc sort" aria-hidden="true" :class="enabled('keys_count', 'asc')"></i></span>
                            <span class="span_sort" @click="toggle('keys_count', 'desc')"><i class="fa fa-sort-amount-desc sort" aria-hidden="true" :class="enabled('keys_count', 'desc')"></i></span>
                        </td>
                    </tr>
                    <tr>
                        <td><Checkbox v-model="model.view.treeNodeName.max_key_ws.enabled" binary /></td>
                        <td class="vertical-align-middle">{{$t('lang.cluster.ws_main_key').capitalize()}}</td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.max_key_ws.color" /></div></td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.max_key_ws.background" /></div></td>
                        <td align="center">
                            <span class="span_sort" @click="toggle('max_key_ws', 'asc')"><i class="fa fa-sort-amount-asc sort" aria-hidden="true" :class="enabled('max_key_ws', 'asc')"></i></span>
                            <span class="span_sort" @click="toggle('max_key_ws', 'desc')"><i class="fa fa-sort-amount-desc sort" aria-hidden="true" :class="enabled('max_key_ws', 'desc')"></i></span>
                        </td>
                    </tr>
                    <tr>
                        <td><Checkbox v-model="model.view.treeNodeName.max_key_wsk.enabled" binary /></td>
                        <td class="vertical-align-middle">{{$t('lang.cluster.wsk_main_key').capitalize()}}</td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.max_key_wsk.color" /></div></td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.max_key_wsk.background" /></div></td>
                        <td align="center">
                            <span class="span_sort" @click="toggle('max_key_wsk', 'asc')"><i class="fa fa-sort-amount-asc sort" aria-hidden="true" :class="enabled('max_key_wsk', 'asc')"></i></span>
                            <span class="span_sort" @click="toggle('max_key_wsk', 'desc')"><i class="fa fa-sort-amount-desc sort" aria-hidden="true" :class="enabled('max_key_wsk', 'desc')"></i></span>
                        </td>
                    </tr>
                    <tr>
                        <td><Checkbox v-model="model.view.treeNodeName.max_key_superwsk.enabled" binary /></td>
                        <td class="vertical-align-middle">{{$t('lang.cluster.superwsk_main_key').capitalize()}}</td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.max_key_superwsk.color" /></div></td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.max_key_superwsk.background" /></div></td>
                        <td align="center">
                            <span class="span_sort" @click="toggle('max_key_superwsk', 'asc')"><i class="fa fa-sort-amount-asc sort" aria-hidden="true" :class="enabled('max_key_superwsk', 'asc')"></i></span>
                            <span class="span_sort" @click="toggle('max_key_superwsk', 'desc')"><i class="fa fa-sort-amount-desc sort" aria-hidden="true" :class="enabled('max_key_superwsk', 'desc')"></i></span>
                        </td>
                    </tr>
                    <tr>
                        <td><Checkbox v-model="model.view.treeNodeName.ws_sum.enabled" binary /></td>
                        <td class="vertical-align-middle">{{$t('lang.cluster.summ_ws').capitalize()}}</td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.ws_sum.color" /></div></td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.ws_sum.background" /></div></td>
                        <td align="center">
                            <span class="span_sort" @click="toggle('ws_sum', 'asc')"><i class="fa fa-sort-amount-asc sort" aria-hidden="true" :class="enabled('ws_sum', 'asc')"></i></span>
                            <span class="span_sort" @click="toggle('ws_sum', 'desc')"><i class="fa fa-sort-amount-desc sort" aria-hidden="true" :class="enabled('ws_sum', 'desc')"></i></span>
                        </td>
                    </tr>
                    <tr>
                        <td><Checkbox v-model="model.view.treeNodeName.wsk_sum.enabled" binary /></td>
                        <td class="vertical-align-middle">{{$t('lang.cluster.summ_wsk').capitalize()}}</td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.wsk_sum.color" /></div></td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.wsk_sum.background" /></div></td>
                        <td align="center">
                            <span class="span_sort" @click="toggle('wsk_sum', 'asc')"><i class="fa fa-sort-amount-asc sort" aria-hidden="true" :class="enabled('wsk_sum', 'asc')"></i></span>
                            <span class="span_sort" @click="toggle('wsk_sum', 'desc')"><i class="fa fa-sort-amount-desc sort" aria-hidden="true" :class="enabled('wsk_sum', 'desc')"></i></span>
                        </td>
                    </tr>
                    <tr>
                        <td><Checkbox v-model="model.view.treeNodeName.superwsk_sum.enabled" binary /></td>
                        <td class="vertical-align-middle">{{$t('lang.cluster.summ_superwsk').capitalize()}}</td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.superwsk_sum.color" /></div></td>
                        <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.superwsk_sum.background" /></div></td>
                        <td align="center">
                            <span class="span_sort" @click="toggle('superwsk_sum', 'asc')"><i class="fa fa-sort-amount-asc sort" aria-hidden="true" :class="enabled('superwsk_sum', 'asc')"></i></span>
                            <span class="span_sort" @click="toggle('superwsk_sum', 'desc')"><i class="fa fa-sort-amount-desc sort" aria-hidden="true" :class="enabled('superwsk_sum', 'desc')"></i></span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Fieldset>
        </template>
    </AdaptersDialog>
</template>
<style scoped>
    fieldset label {margin: 0;}
    .radio{width: 100%}
    .span_sort{cursor: pointer}
    .sort{color: #eee}
    .sort_enabled{color: #000}
    :deep(.p-colorpicker-preview) {width: 15px; height: 15px; border-radius: 50%;}
</style>
